<template>
  <v-container
    class="pa-0 max-width-md"
  >
    <v-card
      flat
      tile
      class="pa-3"
    >
      <v-toolbar
        flat
      >
        <v-toolbar-title>
          {{ $t('dtj.title') }} <!-- 公職法律制度的法律解釋及支援服務 -->
        </v-toolbar-title>
      </v-toolbar>

      <v-row>
        <v-col
          cols="12"
        >
          <v-text-field
            v-model="getStaffName"
            hide-details
            :label="$t('TrainingClient.Identity.name')"
            disabled
          />
        </v-col>
        <v-col
          cols="12"
        >
          <v-text-field
            v-model="getEntityName"
            hide-details
            :label="$t('TrainingClient.Entity')"
            disabled
          />
        </v-col>
      </v-row>
      <v-form ref="boxForm">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="form.email"
              type="text"
              :label="'* ' + $t('dtj.email')"
              :rules="rules.required"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="form.tel"
              :label="'* ' + $t('dtj.tel')"
              :rules="rules.required"
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="form.subject"
              type="text"
              :label="'* ' + $t('dtj.subject')"
              :rules="rules.required"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-textarea
              v-model="form.msgContent"
              outlined
              :label="'* ' + $t('dtj.content')"
              :rules="rules.required"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="pt-0"
          >
            <ul class="text-caption grey--text">
              <li>{{ $t('Box.fileRemark1') }}</li>
              <li>{{ $t('Box.fileRemark2') }}</li>
              <li>{{ $t('Box.fileRemark3') }}</li>
              <li>{{ $t('Box.fileRemark4') }}</li>
            </ul>
            <s-file-uploader
              ref="docUploader"
              :post-url="uploadUrl"
              multiple
              drop
              extensions="bmp,png,jpeg,jpg,gif,txt,doc,docx,pdf,xls,xlsx,ppt,zip,rar,rtf"
              accept=".bmp,.png,.jpeg,.jpg,.gif,.txt,.doc,.docx,.pdf,.xls,.xlsx,.ppt,.zip,.rar,.rtf"
              :maximum="5"
              :size="1024 * 1024 * 5"
            />
          </v-col>
        </v-row>
        <br>
        <v-btn
          color="primary"
          class="ml-0"
          :loading="loading"
          @click="submit"
        >
          {{ $t('Text.Submit') }}
        </v-btn>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>

import VuetifyJetValidator from 'vuetify-jet-validator'
import SFileUploader from '@/components/SFileUploader'
import g2eApi from '../../api/hr/g2e'
import boxApi from '../../api/inbox/dtj'
import boxFileVuex from '../../store/modules/box/file'
import store from '../../store'
import { mapState } from 'vuex'
import { globalModule, boxFileModule } from '../../store/moduleName'
import i18n from '../../i18n'

if (!store.state[boxFileModule]) store.registerModule(boxFileModule, boxFileVuex)

export default {
  components: {
    SFileUploader
  },
  data: function () {
    const validator = new VuetifyJetValidator()
    return {
      staff: null,
      loading: false,
      name: '',
      entity: '',
      form: {
        boxAttachments: [],
        email: '',
        langCode: '',
        subject: '',
        msgContent: '',
        tel: ''
      },
      rules: {
        required: [
          validator.rules.required(this.$t('dtj.RequiredField'))
        ],
        email: [
          validator.rules.required(this.$t('dtj.RequiredField')),
          validator.rules.email(this.$t('Training.Error.FormatInvalid', [this.$t('dtj.email')]))
        ]
      },
      uploadUrl: this.$config.apiDomain.ALI + (this.$config.isProd ? '/ext/ws/box/uploadBoxAttachment' : '/ext/ws/box/uploadBoxAttachment')
    }
  },
  computed: {
    ...mapState({
      files: state => state[boxFileModule].files
    }),

    getStaffName () {
      if (this.staff) {
        return this.$chPtObjData('chinName', this.staff)
      }
      return ''
    },

    getEntityName () {
      if (this.staff) {
        return this.$chPtObjData('entityChinName', this.staff)
      }
      return ''
    }
  },
  watch: {
    '$i18n.locale': function (val) {
      // console.log('update locale')
      this.$router.go()
    }

  },
  created () {
    g2eApi.getStaff(staff => {
      this.staff = staff
      this.name = this.$chPtObjData('chinName', staff)
      this.entity = this.$chPtObjData('entityChinName', staff)
    })
  },
  methods: {
    clearForm: function () {
      this.$refs.boxForm.reset()
      this.form.boxAttachments = []
      this.form.email = ''
      this.form.langCode = ''
      this.form.subject = ''
      this.form.msgContent = ''
      this.form.tel = ''
      // this.$refs.docUploader.clearFile()
    },
    submit: function () {
      this.loading = true
      if (!this.$refs.boxForm.validate()) {
        this.loading = false
        return false
      }

      this.form.langCode = i18n.locale
      this.form.boxAttachments = []
      console.log('files : ' + this.files.length)
      console.log('form.boxAttachments : ' + this.form.boxAttachments.length)
      this.files.forEach((file, i) => {
        console.log('files : ' + JSON.stringify(file) + ' ' + file.response)
        if (file.success) {
          this.form.boxAttachments.push({ docCode: file.response, docName: file.name })
        }
      })
      if (this.form.boxAttachments.length > 5) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Box.fileRemark1'))
        this.loading = false
        return false
      }
      boxApi.submitBoxMessage(this.form, resp => {
        this.loading = false
        console.log('submitBoxMessage, resp : ' + JSON.stringify(resp))
        if (resp.status === 201 || resp.status === 200) {
          //          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('TrainingClient.SaveSuccess'))
          this.$store.commit(boxFileModule + '/clearFiles')

          this.clearForm()

          this.$router.push({ name: 'submitSuccess' })
        }
      })
    }
  }
}
</script>
